import {CloudUploadOutlined, LocalOfferOutlined, ReceiptLongOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import WorkspaceHeader from "../components/common/workspace-header";

export default function DistributorWorkspaceHeader({distributor, tenantType, logoUrl, disabled, onOrders, onUpload, onCoupon}) {
    const {t} = useTranslation();
    const actions = [{label: t("WorkspaceViewOrders"), icon: <ReceiptLongOutlined/>, onClick: onOrders},
        {label: t("UploadProducts"), icon: <CloudUploadOutlined/>, onClick: onUpload},
        {label: t("CreateNewCoupon"), icon: <LocalOfferOutlined/>, onClick: onCoupon}];
    return <WorkspaceHeader title={t("WorkspaceTitle")} companyName={distributor.tenantNameEn} logoUrl={logoUrl}
        typeLabel={tenantType === "IMPORTER" || !tenantType ? t("Distributor") : t(tenantType)} disabled={disabled}
        actions={tenantType === "IMPORTER" ? actions : []}/>;
}
